import { render, staticRenderFns } from "./TypeGift.vue?vue&type=template&id=963776e0&"
import script from "./TypeGift.vue?vue&type=script&lang=js&"
export * from "./TypeGift.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports